import { useMemo } from 'react';
import { debug } from 'zf-web-infra';
import type { TreeService } from '../service';
import type { DataSource, TreeKeys } from '../types';

/**
 * 设置缺省展开的节点
 * @param service
 * @param data
 * @param expendRoot
 * @param defaultExpandedKeys
 * @returns
 */
export function useExpand(
  service: TreeService,
  data: DataSource,
  expendRoot?: boolean,
  defaultExpandedKeys?: TreeKeys
): TreeKeys {
  debug.common('useExpand');

  const result = useMemo(() => service.getDefaultExpandedKeys(
    data,
    expendRoot,
    defaultExpandedKeys
  ), [service, expendRoot, data, defaultExpandedKeys]);

  debug.common('defaultExpandedKeys', result);
  return result;
}
